import {
  gaqlerrExpectedTypeSTRINGFound as expectedTypeSTRINGFound,
  gaqlerrCannotCallFOOonBARTYPEvalue as errCannotCallFOOonBARTYPEvalue
} from '../gaqlerr.js'

// this here as an idea, in case various re engines must be supported
// for now, uses placeholder behaviour converting (very) simple re2 to js re
//
const $re2 = async (gst, qst, args, run) => {
  const regexString = await run(gst, qst, args[0])
  const regexIsFlags = regexString.startsWith('(?i)')
  const flags = regexIsFlags ? 'i' : ''
  const regexStringFinal = regexIsFlags
    ? regexString.slice('(?i)'.length)
    : regexString

  qst.target = new RegExp(regexStringFinal, flags)

  return qst
}

// NOTE rethinkdb uses re2 syntax
// re using re2-specific syntax will fail
// ```
// string.match(regexp) → null/object
// ```
const $match = async (gst, qst, args, run) => {
  const target = qst.target
  const reorstr = await run(gst, qst, args[0])
  const isre = reorstr instanceof RegExp

  if (typeof target !== 'string')
    throw expectedTypeSTRINGFound(typeof target)
  if (typeof reorstr !== 'string' && !isre)
    throw errCannotCallFOOonBARTYPEvalue('match()', typeof target)

  qst.target = isre
    ? reorstr.test(target)
    : target.includes(reorstr)

  return qst
}

// Splits a string into substrings. Splits on whitespace when called with no
// arguments. When called with a separator, splits on that separator. When
// called with a separator and a maximum number of splits, splits on that
// separator at most max_splits times. (Can be called with null as the
// separator if you want to split on whitespace while still specifying
// max_splits.)
//
// Mimics the behavior of Python’s string.split in edge cases, except for
// splitting on the empty string, which instead produces an array of
// single-character strings.
// ```
// string.split([separator, [max_splits]]) → array
// ```
const $split = async (gst, qst, args, run) => {
  const separator = args.length > 0
    ? await run(gst, qst, args[0]) : ' '
  const limit = args.length > 1
    ? await run(gst, qst, args[1]) : undefined

  qst.target = String(qst.target).split(separator, limit)

  return qst
}

const $upcase = (gst, qst) => {
  qst.target = String(qst.target).toUpperCase()

  return qst
}

const $downcase = (gst, qst) => {
  qst.target = String(qst.target).toLowerCase()

  return qst
}

export {
  $re2,
  $match,
  $split,
  $upcase,
  $downcase
}
